<ion-button
  *ngIf="isEnabled$ | async"
  class="verified-worker-badge button-round"
  type="button"
  (click)="handleClick()"
  [attr.aria-label]="label"
>
  <ion-icon
    name="shield-checkmark"
    class="icon"
    aria-hidden="true"
  />
  <span
    *ngIf="label"
    class="label"
  >
    {{ label }}
  </span>
</ion-button>

<ion-modal
  class="verified-worker-badge-modal"
  [isOpen]="isModalOpen"
  (didDismiss)="dismissModal()"
>
  <ng-template>
    <app-verified-worker-badge-modal (onDismiss)="dismissModal()" />
  </ng-template>
</ion-modal>
